export const findLastIndex = (data: any[], veriry: (d: any) => boolean) => {
    for (let i = data.length - 1; i >= 0; i--) {
        if (veriry(data[i])) return i;
    }

    return -1;
};
